module.exports = __webpack_public_path__ + "img/home-06.d12aace4.png";